import { UserCalendarStatus } from 'generated-graphql/types';
import { UseUserCalendarReturnDataItem } from 'modules/calendar/hooks/useUserCalendar';
import { EditableTemplate } from './getTemplateEditBlockedReason';

type Params = {
  // useUserCalendar only returns calendars linked to the current organization.
  calendar?: UseUserCalendarReturnDataItem;
  // Matched no calendar at all — the same thing as its organization link being gone.
  unresolved?: { name: string; email: string };
};

// One shape for getTemplateEditBlockedReason, so the edit page and the list
// reach the same branches.
export const toEditableOrganizer = ({
  calendar,
  unresolved
}: Params): EditableTemplate['organizerUserCalendar'] => {
  if (unresolved) {
    return {
      name: unresolved.name || unresolved.email,
      status: UserCalendarStatus.Connected,
      userCalendarOrganizations: { items: [] }
    };
  }

  return calendar
    ? {
        name: calendar.name,
        status: calendar.status,
        userCalendarOrganizations: {
          items: [{ id: calendar.userCalendarOrganizationId }]
        }
      }
    : null;
};
